import React from "react";
import Link from "next/link";

import { combineClasses } from "@kikoff/utils/src/string";

import styles from "./arrow_link.module.scss";

interface ArrowLinkProps extends React.HTMLProps<HTMLAnchorElement> {
  // Make this required
  href: string;
  useNative?: boolean;
}

const ArrowLink: React.FC<ArrowLinkProps> = ({
  href,
  children,
  className,
  useNative = false,
  ...props
}) => {
  if (useNative)
    return (
      <a
        href={href}
        {...props}
        className={combineClasses(styles["arrow-link"], className)}
      >
        {children}
        <span className={styles.arrow}></span>
      </a>
    );

  return (
    <Link href={href}>
      <a {...props} className={combineClasses(styles["arrow-link"], className)}>
        {children}
        <span className={styles.arrow}></span>
      </a>
    </Link>
  );
};

export default ArrowLink;
